import { Box, Button, Grid, Paper, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { PatientMatchCandidates, PatientMatchCandidatesProps } from './PatientMatchCandidates'

export type ConflictDetailsProps = {
  onResolveConflict: (conflictId: string, resolution: 'local' | 'remote' | 'merge', mergeData?: any) => void
} & PatientMatchCandidatesProps

export function ConflictDetails({ conflict, loading, onResolveConflict, onResolvePatientDuplicate }: ConflictDetailsProps) {
  const { t } = useTranslation()
  return (
    <Box sx={{ p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle2" gutterBottom>
            {t('sync.conflict.localData')}:
          </Typography>
          <Paper sx={{ p: 2, bgcolor: 'background.paper' }}>
            <pre style={{ fontSize: '12px', margin: 0, whiteSpace: 'pre-wrap' }}>{JSON.stringify(conflict.localData, null, 2)}</pre>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle2" gutterBottom>
            {t('sync.conflict.remoteData')}:
          </Typography>
          <Paper sx={{ p: 2, bgcolor: 'background.paper' }}>
            <pre style={{ fontSize: '12px', margin: 0, whiteSpace: 'pre-wrap' }}>{JSON.stringify(conflict.remoteData, null, 2)}</pre>
          </Paper>
        </Grid>
      </Grid>

      {conflict.conflictType === 'duplicate' && (
        <PatientMatchCandidates conflict={conflict} onResolvePatientDuplicate={onResolvePatientDuplicate} loading={loading} />
      )}

      <Stack direction="row" spacing={2} sx={{ mt: 3 }}>
        <Button variant="contained" color="primary" onClick={() => onResolveConflict(conflict._id, 'local')} disabled={loading}>
          {t('sync.conflict.useLocalData')}
        </Button>
        <Button variant="outlined" color="primary" onClick={() => onResolveConflict(conflict._id, 'remote')} disabled={loading}>
          {t('sync.conflict.useRemoteData')}
        </Button>
        {conflict.conflictType === 'duplicate' && (
          <Button variant="outlined" color="secondary" onClick={() => onResolveConflict(conflict._id, 'merge')} disabled={loading}>
            {t('sync.conflict.mergeData')}
          </Button>
        )}
      </Stack>
    </Box>
  )
}
